import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styles from './style.module.scss';

const SpecialCaseCard = ({ item }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          mail,
        }
      }
    }
  `);

  return (
    <a
      href={`mailto:${data.site.siteMetadata.mail}`}
      style={{ textDecoration: 'none' }}
    >
      <div className={styles.containerMain}>
        <div className={styles.container}>
          <h1>{item.title}</h1>
        </div>
      </div>
    </a>
  );
};

export default SpecialCaseCard;
